import { Header3 } from '@cian/ui-kit/typography';

import { FC, useCallback, useState } from 'react';

import { ButtonWithAnalyticEvent } from 'shared/containers/ButtonWithAnalyticEvent';
import { trackOpenContacts } from 'shared/store/analytics/actions/trackOpenContacts';

import { PhoneButton } from '../UI/Buttons';

import { IShowPhoneButtonProps } from './types';

import * as styles from './ShowPhoneButton.css';

export const ShowPhoneButton: FC<IShowPhoneButtonProps> = props => {
  const { onClick, phone, disableButtonIfPhoneEmpty = false, hideButtonIfPhoneEmpty = false } = props;

  const [phoneVisible, setPhoneVisibility] = useState<boolean>(false);

  const handleClick = useCallback(() => {
    setPhoneVisibility(true);
    onClick?.();
  }, [onClick]);

  if (hideButtonIfPhoneEmpty && !phone) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {phoneVisible ? (
        <Header3 color="black_100">{phone}</Header3>
      ) : (
        <ButtonWithAnalyticEvent
          customView={PhoneButton}
          disabled={disableButtonIfPhoneEmpty && !phone}
          trackAnalyticEvent={trackOpenContacts}
          onClick={handleClick}
        >
          Показать телефон
        </ButtonWithAnalyticEvent>
      )}
    </div>
  );
};

ShowPhoneButton.displayName = 'ShowPhoneButton';
